import React from 'react';

export default function useEllipsis(max) {
  const isBrowser = typeof window !== 'undefined';
  const ref = React.useRef(null);

  const handleTextEllipsis = () => {
    if (ref && ref.current) {
      const wordArray = ref.current.innerHTML.split(' ');
      while (ref.current.scrollHeight > max) {
        wordArray.pop();
        ref.current.innerHTML = `${wordArray.join(' ')}...`;
      }
    }
  };

  React.useEffect(() => {
    if (isBrowser) {
      handleTextEllipsis();
      window.addEventListener('resize', handleTextEllipsis);
    }
    return () => {
      if (isBrowser) {
        window.removeEventListener('resize', handleTextEllipsis);
      }
    };
  });

  return ref;
}
